import * as React from "react";
import { Box } from "@sqymagma/elements";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, ChartDataset } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";

import globaltheme from "@themes/globaltheme";
import { useStyle } from "@contexts";
import { THEMES } from "@constants";

ChartJS.register(annotationPlugin);

ChartJS.defaults.font.family = "'Gilroy', sans-serif";

interface ChartProps {
  labels?: Array<string>;
  datasets: Array<ChartDataset<"bar">>;
}

const Chart = (props: ChartProps) => {
  const { labels, datasets } = props;

  const { theme } = useStyle();
  const isDarkTheme = theme === THEMES.dark;

  return (
    <Box position="relative" width="100%">
      <Bar
        data={{
          labels,
          datasets: datasets.map((dataset) => ({
            backgroundColor: function (context) {
              const value = context.raw;
              return value === 0
                ? globaltheme.color.colors.darkgray.value
                : globaltheme.color.colors.primary.value;
            },
            borderWidth: 0,
            borderRadius: 5,
            minBarLength: 3,
            ...dataset,
          })),
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
            annotation: {
              annotations: {
                milestone1: {
                  type: "line",
                  yMin: 40000,
                  yMax: 40000,
                  borderColor: isDarkTheme
                    ? globaltheme.color.colors.dark.value
                    : globaltheme.color.colors.light.value,
                  borderWidth: 1,
                  borderDash: [6, 6],
                  label: {
                    content: "40k",
                    position: "start",
                  },
                },
                milestone2: {
                  type: "line",
                  yMin: 70000,
                  yMax: 70000,
                  borderColor: isDarkTheme
                    ? globaltheme.color.colors.dark.value
                    : globaltheme.color.colors.light.value,
                  borderWidth: 1,
                  borderDash: [6, 6],
                  label: {
                    content: "70k",
                    position: "start",
                  },
                },
              },
            },
            tooltip: {
              displayColors: false,
              callbacks: {
                label: (tooltipItem) => {
                  const value = Number(tooltipItem.raw);
                  return `${value.toLocaleString()} pasos`;
                },
                title: () => "",
              },
            },
          },
          scales: {
            x: {
              grid: { display: false },
              border: { display: false },
              ticks: {
                color: isDarkTheme ? "#101010" : "#ffffff",
                maxRotation: 0,
                font: { size: 8.5 },
                callback: (index) => {
                  if (!labels) return "";
                  const lastSpaceIndex =
                    labels?.[Number(index)].lastIndexOf(" ");
                  const value = [
                    labels?.[Number(index)].slice(0, lastSpaceIndex),
                    labels?.[Number(index)].slice(lastSpaceIndex),
                  ];
                  return value;
                },
              },
            },
            y: { display: false },
          },
        }}
      />
    </Box>
  );
};

export default Chart;
